// @module Convergence.ShopByCatBrand.ShopByCatBrand
define('Convergence.ShopByCatBrand.ShopByCatBrand.View'
,	[
	'convergence_shopbycatbrand_shopbycatbrand.tpl'
	
	,	'Backbone'
    ]
, function (
	convergence_shopbycatbrand_shopbycatbrand_tpl
	
	,	Backbone
)
{
    'use strict';

	// @class Convergence.ShopByCatBrand.ShopByCatBrand.View @extends Backbone.View
	return Backbone.View.extend({

		template: convergence_shopbycatbrand_shopbycatbrand_tpl

	,	initialize: function (options) {
		// console.log('Convergence.ShopByCatBrand.ShopByCatBrand.View.initialize', options);
		
			var self = this;
			this.collection = options.collection ; // Collection passed from the module
			this.selectedCategory = options.currentSelectedObj; // Current selected category object
			this.createInitObj = options.createInitObj; // Initial object for creating categories
			this.selectedCat = this.selectedCategory.categoryID ;
			   this.collection.reset([{attributes: {recordRes: []}}]);
			this.collection.on('sync',this.render,this);
			this.fetchData();
			
		}
	,	 fetchData: function() {
            var self = this;
            // console.log('Fetching data for category:', this.selectedCategory);
            
            return this.collection.fetch({
                data: {
                    SelectedCategoriesID: this.selectedCategory.categoryID,
                    SelectedCategoriesint_id: this.selectedCategory.CategoriesinitID 
                }
            }).done(function(res) {
                // console.log('Data fetched successfully:', res);
            });
        }
	// ,	beforeShowContent: function beforeShowContent() {
	// 	var self = this;
	// 	console.log('Convergence.ShopByCatBrand.ShopByCatBrand.View.beforeShowContent', this.selectedCategory);
		
	// 		this.collection.fetch({
	// 			data:{
	// 				SelectedCategoriesID:self.selectedCategory.categoryID,
	// 				SelectedCategoriesint_id:self.selectedCategory.CategoriesinitID 
	// 			}
	// 		}).done(function(res) {
	// 			// self.render();
	// 			console.log('Data fetched successfully:', res);
	// 		});
	// 	}

	,	events: {
			'click [data-action="ToggleBrands"]':'ToggleBrands'
		}

		, ToggleBrands: function (e) {
			e.preventDefault();
			// var self
			// Vanilla JS access (note the lowercase conversion)
			var categoriesInitId = e.currentTarget.dataset.categoriesinitid;
			var categoryId = e.currentTarget.dataset.categoryid;

			this.selectedCat = categoryId;

			this.collection.fetch({
				data:{
					SelectedCategoriesID:categoryId, 
					SelectedCategoriesint_id:categoriesInitId
				}
			})



			// console.log('Vanilla JS:', categoriesInitId, categoryId);

		}

	,	bindings: { 
		}

	, 	childViews: {

		}

		//@method getContext @return Convergence.ShopByCatBrand.ShopByCatBrand.View.Context
	,	getContext: function getContext()
		{
			var self = this;
			
			// console.log('selectedCategory',this.selectedCategory) 
			_.each(this.createInitObj,function(data){
				data.isSelected = false;
				if(data.categoryID === self.selectedCat){
					data.isSelected = true;
				}
			})
			// console.log('createInitObj',this.createInitObj) 
			//@class Convergence.ShopByCatBrand.ShopByCatBrand.View.Context
			
			return {
				models: this.collection.models[0].attributes.recordRes || [],
				buttonsArr : this.createInitObj
			};
		}
	});
});
